<div class="mdt-root" #pickerRoot [class.mdt-ready]="ready">
  <div class="mdt-backdrop" (click)="dismiss()"></div>
  <div
    class="mdt-panel"
    role="dialog"
    [attr.aria-label]="dateOnly ? 'Choose date' : 'Choose date and time'"
    [style.top.px]="top"
    [style.left.px]="left"
    (click)="$event.stopPropagation()">
    <div class="mdt-body">
      <div class="mdt-cal">
        <div class="mdt-cal-header">
          <button type="button" class="mdt-view-btn" (click)="toggleYearView()" [attr.aria-expanded]="view === 'year'">
            <span>{{ monthYearLabel }}</span>
            <span class="mdt-chevron" [class.open]="view === 'year'" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="22" height="22">
                <path fill="currentColor" d="M7 10l5 5 5-5z"></path>
              </svg>
            </span>
          </button>
          <div class="mdt-nav" *ngIf="view === 'day'">
            <button type="button" class="mdt-nav-btn" aria-label="Previous month" [disabled]="!canGoPrevious" (click)="previousMonth()">
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path fill="currentColor" d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
              </svg>
            </button>
            <button type="button" class="mdt-nav-btn" aria-label="Next month" [disabled]="!canGoNext" (click)="nextMonth()">
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path fill="currentColor" d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
              </svg>
            </button>
          </div>
        </div>

        <div class="mdt-cal-body">
          <ng-container *ngIf="view === 'day'">
            <div class="mdt-weekdays">
              <span *ngFor="let weekday of weekdays">{{ weekday }}</span>
            </div>
            <div class="mdt-days">
              <ng-container *ngFor="let cell of dayCells">
                <button
                  *ngIf="cell.inMonth"
                  type="button"
                  class="mdt-day"
                  [class.selected]="cell.day === day"
                  [class.today]="cell.today"
                  (click)="selectDay(cell)">
                  {{ cell.day }}
                </button>
                <span *ngIf="!cell.inMonth" class="mdt-day mdt-day-empty"></span>
              </ng-container>
            </div>
          </ng-container>

          <div class="mdt-years" *ngIf="view === 'year'">
            <button
              type="button"
              class="mdt-year"
              *ngFor="let item of years"
              [class.selected]="item === year"
              (click)="selectYear(item)">
              {{ item }}
            </button>
          </div>
        </div>
      </div>

      <div class="mdt-time" *ngIf="!dateOnly">
        <div class="mdt-time-col">
          <button
            type="button"
            class="mdt-time-item"
            *ngFor="let hour of hours"
            [class.selected]="hour === hour12"
            (click)="selectHour(hour)">
            {{ pad(hour) }}
          </button>
        </div>
        <div class="mdt-time-col">
          <button
            type="button"
            class="mdt-time-item"
            *ngFor="let item of minutes"
            [class.selected]="item === minute"
            (click)="selectMinute(item)">
            {{ pad(item) }}
          </button>
        </div>
        <div class="mdt-time-col">
          <button type="button" class="mdt-time-item" [class.selected]="meridiem === 'AM'" (click)="selectMeridiem('AM')">AM</button>
          <button type="button" class="mdt-time-item" [class.selected]="meridiem === 'PM'" (click)="selectMeridiem('PM')">PM</button>
        </div>
      </div>
    </div>

    <div class="mdt-actions">
      <button type="button" class="mdt-action" (click)="dismiss()">Cancel</button>
      <button type="button" class="mdt-action" (click)="accept()">OK</button>
    </div>
  </div>
</div>
